export async function getConfigStorePaths(
  configStoreKey: string
): Promise<string[]> {
  const { client } = await useOpenFeature()
  const value = client.getStringValue(configStoreKey, 'control')
  const path = `/api/v2/configs/${configStoreKey}`
  return [`${path}/${value}.json`, `${path}/control.json`]
}
